import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { VideoPreview } from './components/VideoPreview';
import { PackContents } from './components/PackContents';
import { Benefits } from './components/Benefits';
import { PainPoints } from './components/PainPoints';
import { Solution, Audience } from './components/Solution';
import { DigitalAccess } from './components/DigitalAccess';
import { Pricing, FinalUrgency } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Contact, Footer } from './components/Footer';
import { EmotionalClose } from './components/EmotionalClose';
import { PAGE_TITLE, PAGE_DESCRIPTION } from './data/pack';
export function App({
  showLaunchUrgency = true
}: {
  showLaunchUrgency?: boolean;
}) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  useEffect(() => {
    document.title = PAGE_TITLE;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', PAGE_DESCRIPTION);
  }, []);
  return <div className="min-h-screen w-full bg-brand-surface font-sans text-brand-text selection:bg-brand-goldLight/50" data-id="element-0" data-mp="4n7g6m8exco">
      {showLaunchUrgency && <UrgencyBanner data-id="element-1" data-mp="2znfy0adui2o6" />}
      <Hero data-id="element-2" data-mp="33m5cy7ej7s9x" />
      <VideoPreview data-id="element-3" data-mp="33lx18iu5at0b" />
      <PackContents data-id="element-4" data-mp="33n6yx6x35z6f" />
      <Benefits data-id="element-5" data-mp="33orjc3pos1qk" />
      <PainPoints data-id="element-6" data-mp="38lrq6gud18iq" />
      <Solution data-id="element-7" data-mp="38l8gtoirzsgb" />
      <Audience data-id="element-8" data-mp="38kqb81a841vq" />
      <Pricing data-id="element-9" data-mp="38k6uup081ljt" />
      <DigitalAccess data-id="element-10" data-mp="38nup5qdhqbzl" />
      <Guarantee data-id="element-11" data-mp="3dkuwe4m2tksa" />
      <FAQ data-id="element-12" data-mp="3dle30p6a0mr0" />
      <CostComparison data-id="element-13" data-mp="3dl4k1ljnffut" />
      <EmotionalClose data-id="element-14" data-mp="3dmfolnkx4rmz" />
      {showLaunchUrgency && <FinalUrgency data-id="element-15" data-mp="nvsvh92bsvy2" />}
      <Contact data-id="element-16" data-mp="nwc0jp6vnpuo" />
      <Footer data-id="element-17" data-mp="nur6e0oh68xc" />
    </div>;
}